module.exports = __webpack_public_path__ + "static/img/img(38).880bfca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(38).png
// module id = Sy7x
// module chunks = 1